import './index.css';
export default {
  name: 'input-select',
  props: {
    value: {
      type: [String, Date, Object, Number],
      default: () => ''
    },
    values: {
      type: Array,
      default: () => []
    },
    vAlias: {
      type: String,
      default: 'name'
    },
    vValue: {
      type: String,
      default: 'id'
    },

    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: ''
    },
    help: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      inputValue: ''
    }
  },
  created() {
    this.$nextTick(() => {
      this.inputValue = this.$props.value;
    });
  },
  watch: {
    'inputValue'(newVal) {
      this.$emit('input', newVal);
      this.$emit('change', newVal);
      this.onSelect();
    },
    '$props.value'(newVal) {
      if (this.inputValue != newVal)
        this.inputValue = newVal;
    }
  },
  computed: {
    id() {
      return this._uid;
    }
  },
  methods: {
    onChange(e) {
      this.inputValue = e.target.value;
    },
    onSelect() {
      let selected = '';
      selected = this.$props.values.find(item => item[this.$props.vValue] == this.inputValue);
      this.$emit('select', selected);
    }
  }
}
